export const timelineBackgroundAdsFallbackColor = 'rgba(255, 219, 28, 0.3)';
export const timelineBackgroundFallbackColor = 'rgba(255, 255, 255, 0.3)';
export const timelineProgressAdsFallbackColor = 'rgba(255, 219, 28, 1.0)';
export const timelineProgressLiveFallbackColor = 'transparent';
export const timelineProgressFallbackColor = 'rgba(255, 255, 255, 1.0)';
export const makeTimelineBackgroundContainerColor = (customStyles, isPlayingClientAd) => {
    var _a, _b;
    if (isPlayingClientAd)
        return ((_a = customStyles.backgroundAds) === null || _a === void 0 ? void 0 : _a.backgroundColor) || timelineBackgroundAdsFallbackColor;
    return ((_b = customStyles.backgroundContainer) === null || _b === void 0 ? void 0 : _b.backgroundColor) || timelineBackgroundFallbackColor;
};
export const makeTimelineProgressBarColor = (customStyles, isPlayingClientAd, isOnLiveEdge) => {
    var _a, _b, _c, _d;
    if (isPlayingClientAd)
        return ((_a = customStyles.progressAds) === null || _a === void 0 ? void 0 : _a.backgroundColor) || timelineProgressAdsFallbackColor;
    if (isOnLiveEdge)
        return ((_b = customStyles.progressLive) === null || _b === void 0 ? void 0 : _b.backgroundColor) || timelineProgressLiveFallbackColor;
    return (((_c = customStyles.progressBar) === null || _c === void 0 ? void 0 : _c.backgroundColor) ||
        ((_d = customStyles.progressDot) === null || _d === void 0 ? void 0 : _d.backgroundColor) ||
        timelineProgressFallbackColor);
};
//# sourceMappingURL=styles.js.map